/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolGroupIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-group"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M-0.47 17.95Q-0.47 16.93 0.01 16.1Q0.5 15.28 1.32 14.85Q2.98 14 4.74 13.57Q6.5 13.15 8.3 13.15Q10.1 13.15 11.85 13.57Q13.6 14 15.25 14.85Q16.07 15.28 16.56 16.1Q17.05 16.93 17.05 17.95L17.05 18.88Q17.05 20 16.29 20.76Q15.53 21.52 14.4 21.52L2.17 21.52Q1.05 21.52 0.29 20.76Q-0.47 20 -0.47 18.88ZM18.23 21.52Q18.65 20.95 18.85 20.27Q19.05 19.6 19.05 18.88L19.05 17.95Q19.05 16.9 18.44 15.5Q17.82 14.1 16.4 13.2Q18.13 13.32 19.6 13.75Q21.07 14.18 22.32 14.85Q23.4 15.43 23.94 16.16Q24.48 16.9 24.48 17.65L24.48 18.88Q24.48 20 23.71 20.76Q22.95 21.52 21.82 21.52ZM8.28 11.82Q8.28 11.82 7.3 11.82Q6.33 11.82 4.95 10.45Q3.58 9.07 3.58 7.13Q3.58 5.17 4.95 3.8Q6.33 2.42 8.28 2.42Q10.22 2.42 11.6 3.8Q12.97 5.17 12.97 7.13Q12.97 9.07 11.6 10.45Q10.22 11.82 8.28 11.82ZM20.4 7.13Q20.4 7.13 20.4 8.1Q20.4 9.07 19.02 10.45Q17.65 11.82 15.7 11.82Q15.32 11.82 14.68 11.74Q14.03 11.65 13.65 11.53Q14.38 10.57 14.74 9.45Q15.1 8.32 15.1 7.13Q15.1 5.92 14.74 4.8Q14.38 3.67 13.65 2.73Q14.15 2.55 14.68 2.49Q15.2 2.42 15.7 2.42Q17.65 2.42 19.02 3.8Q20.4 5.17 20.4 7.13Z" fill={color} />
    </svg>
  );
}
